<template>
  <div class="HeaderBar">
    <div :class="{'menu-show': showHeaderBarNav}" class="header-bar-nav">
      <div class="left">
        <div @click="handleLogoGA($event, preHref)" >
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
            <g id="udnLogo">
              <path :style="{'fill': iconColor}" id="Path_736" data-name="Path 736" d="M84.648,145.672a.935.935,0,0,0-.2-.931c-.161-.1-.448-.506-.816-.184s-.483.6-.713.69a5.119,5.119,0,0,0-.529.264.575.575,0,0,0-.4.77,5.445,5.445,0,0,0,1.265,1.449c.31.207.862-.126.977-.54A9.16,9.16,0,0,1,84.648,145.672Z" transform="translate(-73.172 -128.147)" fill="#7b7a7a"/>
              <path :style="{'fill': iconColor}" id="Path_737" data-name="Path 737" d="M69.226,224.282a22.452,22.452,0,0,0-2.426,2.2,14.969,14.969,0,0,0,1.794.966,12.171,12.171,0,0,0,1.518-1.989C70.537,224.558,69.686,224.017,69.226,224.282Z" transform="translate(-59.763 -198.753)" fill="#7b7a7a"/>
              <path :style="{'fill': iconColor}" id="Path_738" data-name="Path 738" d="M32.453,179.473c-.575-.494-.586-.632-1.138-.31s-.529.184-.667.31-1.794,1.748-2.093,2.035l-.655.609a15.072,15.072,0,0,0,.989,1.3c.448-.471,1-1.012,1.311-1.3a6.513,6.513,0,0,1,1.276-1.081,1.713,1.713,0,0,0,.816-.448C32.718,180.244,33.028,179.979,32.453,179.473Z" transform="translate(-25.336 -158.728)" fill="#7b7a7a"/>
              <path :style="{'fill': iconColor}" id="Path_739" data-name="Path 739" d="M16.844,155.687c-.31.241-2.392,2.162-2.829,2.541l-.115.092a14.929,14.929,0,0,0,.77,1.713c.207-.242.4-.471.552-.621.333-.322,1.713-1.667,2.231-2.081s.632-.69.414-1.115S17.154,155.445,16.844,155.687Z" transform="translate(-12.946 -138.035)" fill="#7b7a7a"/>
              <path :style="{'fill': iconColor}" id="Path_740" data-name="Path 740" d="M138.6,78.28c.058-.253-.264-.667-.54-.494s-.77.736-1.242,1.15-.954.8-.954.8a9.175,9.175,0,0,0-.851,1.161c-.161.253-.172.425.092.54s1.311-.046,1.943.368.989.494,1.219.356.161-.517.046-.9a5.579,5.579,0,0,1,.173-1.978A5.809,5.809,0,0,0,138.6,78.28Z" transform="translate(-120.032 -69.126)" fill="#7b7a7a"/>
              <path :style="{'fill': iconColor}" id="Path_741" data-name="Path 741" d="M47.783,196.524a.981.981,0,0,0-1.1-.793c-.448.115-.8.736-.8.736s-1.035.943-1.633,1.46L43,199.042a15.1,15.1,0,0,0,1.265,1.15,14.442,14.442,0,0,1,1.092-1.184c.3-.265,1.334-1.276,1.61-1.437S47.921,197.087,47.783,196.524Z" transform="translate(-38.7 -173.525)" fill="#7b7a7a"/>
              <path :style="{'fill': iconColor}" id="Path_742" data-name="Path 742" d="M206.561,30.5c-.2.172-.862.724-.943.828s-.448.356.184.736a3.211,3.211,0,0,0,1.794.471,5.8,5.8,0,0,1,1.69.379,15.1,15.1,0,0,0-2.61-2.61.587.587,0,0,1-.115.2Z" transform="translate(-182.46 -27.138)" fill="#7b7a7a"/>
              <path :style="{'fill': iconColor}" id="Path_743" data-name="Path 743" d="M7.946,18.416a9.237,9.237,0,0,1,2.242-1.748c.9-.471,1.311-.08,1.909.368s.759.345,1.092.011.161-.724.218-1.253.057-1.989.161-2.7.011-1.012.632-1.564,1.414-.437,2.311-.391a7.073,7.073,0,0,1,2.346.747,4.911,4.911,0,0,0,1.184.563.768.768,0,0,0,.759-.517c.046-.172-.057-1.012,0-1.311s.046-1.771.057-2.024a10.877,10.877,0,0,1,.552-3.519c.287-.828.379-.989.736-.977s1.552-.115,2.622-.08a20.589,20.589,0,0,1,2.645.414A15.02,15.02,0,0,0,5.8,20.244C6.853,19.37,7.842,18.508,7.946,18.416Z" transform="translate(-5.6 -2.8)" fill="#7b7a7a"/>
              <path :style="{'fill': iconColor}" id="Path_744" data-name="Path 744" d="M180.644,60.274a.421.421,0,0,0,.678.1c.3-.253,1.276-1.219,1.506-1.391s.494-.391.264-.644a4.853,4.853,0,0,0-1.276-.954c-.23-.035-.471-.184-.69.046s-.828.759-.828.759a1.458,1.458,0,0,0-.287.943A3.258,3.258,0,0,0,180.644,60.274Z" transform="translate(-159.946 -51.039)" fill="#7b7a7a"/>
              <path :style="{'fill': iconColor}" id="Path_745" data-name="Path 745" d="M117.929,69.978a2.029,2.029,0,0,1-1.23-.575,6.666,6.666,0,0,1-1-1.575c-.276-.54-1.012-1.081-1.15-1.449s.184-.264.563-.253l.506-.127c.241-.08.908-.345,1.322-.54a4.943,4.943,0,0,0,1.15-.667l.529-.414a14.972,14.972,0,0,0-1.081-1.978h0c-.184.3-1.357.77-1.541.9a13.765,13.765,0,0,1-1.058.885,7.3,7.3,0,0,1-1.207.632,20.343,20.343,0,0,0-1.9,1.863c-.276.264-.655.575-.874.828s-.241.586-.69.931c-.126.1-.207.276-.322.368a5,5,0,0,0-.483.322c-.161.149-.6.057-.724.172a.8.8,0,0,0-.3.839c0,.253-.391.448-.46.609s-.172.563-.023.747.414.678.8.851a6.731,6.731,0,0,1,1.414,1.115c.483.448.529.678.4,1.449a1.233,1.233,0,0,1-1.621.828c-.632-.172-.828-.943-.908-1.587a11.025,11.025,0,0,0-.644-2.127.545.545,0,0,0-.862-.276,20.91,20.91,0,0,0-2.231,2.15,1.082,1.082,0,0,0-.253,1.253c.092.333.529.609.736.8a5.154,5.154,0,0,0,1.437.609c.368.092.816.23.851.54a2.846,2.846,0,0,1-.621,1.782c-.483.517-1.552.322-2.1-.069s-.149-.977-.069-1.311a1.133,1.133,0,0,0-.161-.724,1.9,1.9,0,0,0-.529-1.334c-.276-.31-.46-.149-.667.023a5.377,5.377,0,0,0-1.069,1.621c-.046.356.9,1.61.9,1.61,1.345,2.277.23,3.484-.747,4.841C101.693,84,101.3,84.5,100.9,85a15.018,15.018,0,0,0,18.858-16.812C119.321,69.392,118.412,70.013,117.929,69.978Zm-4,3.323c-1.023.414-1.518-.54-1.759-1.023s-.839-1.276-1.035-1.656a2.968,2.968,0,0,1,0-1.587c.092-.483.356-.345.552-.241a9.51,9.51,0,0,1,.989.345,6.393,6.393,0,0,1,2.035,2.208A1.247,1.247,0,0,1,113.928,73.3Z" transform="translate(-89.942 -55.546)" fill="#7b7a7a"/>
              <path :style="{'fill': iconColor}" id="Path_746" data-name="Path 746" d="M156.7,31.456a11.1,11.1,0,0,0-.943-.839,1.111,1.111,0,0,0-.77-.011l-.759.517a2.093,2.093,0,0,0-.6.862,1.531,1.531,0,0,0,.3,1.058c.184.3.425.839.966.54a13.669,13.669,0,0,0,1.759-1.506C156.857,31.893,156.949,31.663,156.7,31.456Z" transform="translate(-136.585 -27.351)" fill="#7b7a7a"/>
              <path :style="{'fill': iconColor}" id="Path_747" data-name="Path 747" d="M113.927,120.738c.115.1.529.4,1.092-.161s.782-.851,1.035-1.115.632-.69.437-1.081-.632-.966-1.276-.678a5.393,5.393,0,0,0-1.207.713l-.31.276a1.248,1.248,0,0,0-.31,1.23A1.3,1.3,0,0,0,113.927,120.738Z" transform="translate(-100.946 -104.42)" fill="#7b7a7a"/>
              <path :style="{'fill': iconColor}" id="Path_748" data-name="Path 748" d="M91.445,98.278c.356-.379.2-.552-.08-.966s-.828-.471-1.633-.4a1.59,1.59,0,0,0-1.276,1.115,2.624,2.624,0,0,0-.184.851,2.237,2.237,0,0,0,.9,1.15c.391.207.724-.046,1.1-.552A12.948,12.948,0,0,1,91.445,98.278Z" transform="translate(-78.762 -86.065)" fill="#7b7a7a"/>
            </g>
          </svg>
        </div> 
      </div>
      <div class="right">
        <span class="right-icon">
          <share-facebook-button :href="facebookShareURL" :icon-color="iconColor" />
        </span>
        <span class="right-icon">
          <share-line-button :href="lineShareURL" :icon-color="iconColor" />
        </span>
        <span @click="handleClickMenuBtn" :class="{'active': onMenuClick}" class="right-icon menu-button">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
            <g id="line1">
              <rect id="Rectangle_505" class="st0" width="30" height="30"/>
              <path  :style="{'stroke': iconColor}" id="Path_1413" class="st1" d="M5.5,22h20"/>
            </g>
            <g id="line2">
              <path  :style="{'stroke': iconColor}" id="Path_1411" class="st1" d="M12.5,15h13"/>
            </g>
            <g id="line3">
              <path  :style="{'stroke': iconColor}" id="Path_1412" class="st1" d="M5.5,8h20"/>
            </g>
          </svg>
        </span>
      </div>
    </div>
    <div  class="header-bar-cover" :class="[onMenuClick ? 'active' : 'inactive']">     
      <ul class="cover-lists">
        <li v-show="onMenuClick" @click="handleMenuGA($event, list.id)" :class="{'active': list.isActive}"  class="cover-list" v-for="list in lists" :key="list.id">
          <a target="_blank" :href="preHref + list.id + '/'">{{ list.title }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ShareFacebookButton from './ShareFacebookButton.vue'
import ShareLineButton from './ShareLineButton.vue'
import Utils from 'udn-newmedia-utils'

export default {
  name: 'HeaderBar',
  data () {
    return {
      onMenuClick: false,
      showHeaderBarNav: true,
      lists: [
      {
        id: 'people/children',
        title: '20年了 災民們過得好嗎？',
        isActive: false
      },
      {
        id: 'rebuild',
        title: '堅持20年的重建路',
        isActive: false
      },
      {
        id: 'live',
        title: '建築耐震總體檢',
        isActive: false
      },
      {
        id: 'resilientcity',
        title: '爭取求生秒數',
        isActive: false
      },
      {
        id: 'safehome',
        title: '你家耐震嗎？',
        isActive: false
      },
      {
        id: 'memory',
        title: '寫一封信給921',
        isActive: false
      }
      ],
      lastScrollPosition: 0
    }
  },
  components: {
    ShareFacebookButton,
    ShareLineButton
  },
  props: {
    preHref: {
      type: String,
      default: '../'
    },
    pageName: {
      type: String,
      default: 'people',
      required: true
    },
    iconColor: {
      type: String,
      default: '#7b7a7a'
    },
    udnLogoUrl: {
      type: String,
      default: window.location.href
    },
    facebookShareURL: {
      type: String,
      default: window.location.href
    },
    lineShareURL: {
      type: String,
      default: window.location.href
    }
  },
  mounted () {
    let vm = this
    vm.lists.forEach((list)=>{
      if( list.id === vm.pageName ) {
        list.isActive = true
      }
    })

    window.addEventListener('scroll', this.handleScrollHeaderBarShow, false);
    
  },
  methods: {
    handleClickMenuBtn () {
      this.handleBurgerGA()
      this.onMenuClick = !this.onMenuClick
    },
    handleScrollHeaderBarShow () {
      let scrollPostion = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollPostion > this.lastScrollPosition && this.onMenuClick === false ){
        this.showHeaderBarNav = false
      } else {
        this.showHeaderBarNav = true
      }
      this.lastScrollPosition = scrollPostion <= 0 ? 0 : scrollPostion;
    },
    handleBurgerGA () {
      window.ga('newmedia.send', 'event', {
        eventCategory: 'menubar',
        eventAction: 'click',
        eventLabel: "[" + Utils.detectPlatform() + "][" + document.querySelector('title').innerHTML + "][ hamburger ]"
      });
    },
    handleMenuGA (event, name) {
      window.ga('newmedia.send', 'event', {
        eventCategory: 'menubar',
        eventAction: 'click',
        eventLabel: "[" + Utils.detectPlatform() + "][" + document.querySelector('title').innerHTML + "] [" + event.target.href + "][ " + name + " ]"
      });
    },
    handleLogoGA (event, preHref) {
      window.ga('newmedia.send', 'event', {
        eventCategory: 'logo',
        eventAction: 'click',
        eventLabel: "[" + Utils.detectPlatform() + "][" + document.querySelector('title').innerHTML + "] [" + this.udnLogoUrl + "][ 圓形聯logo ]"
      });
      setTimeout(function() {
        document.location.href = preHref;
      }, 100);
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScrollHeaderBarShow);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.HeaderBar {
  position: fixed;
  top: 0;
  z-index: 5500;
  width: 100%;
    .header-bar-nav {
      height: 50px;
      padding: 10px;
      position: relative;
      display: flex;
      justify-content: space-between;
      z-index: 90;
      transform: translateY(-100%);
      transition: all .7s ease;
      -webkit-transition:  all .7s ease;
      &.menu-show {
        transition: all .7s ease;
        -webkit-transition:  all .7s ease;
        transform: translateY(0);
      }
      img {
        width: 30px;
        height: 30px;
      }
      .left {
        svg {
          cursor: pointer;
          transition: all 1s;
          &:hover #udnLogo path {
            fill: #57b09f !important;
            transition: all .5s;
          }
        }
      }
      .right {
        .right-icon {
          margin-left: 14px;
        }
        .menu-button {
            width: 30px;
            height: 30px;
            display: inline-block;
            cursor: pointer;
            &:hover svg g path {
              stroke: #57b09f !important;
              transition: all .5s;
            }
            .st0{
              fill:none;
            }
            .st1{
              fill:none;stroke-width:1.5;stroke-linecap:round;
            }
            #line2 {
              -webkit-transition-property: all; /* Safari */
              -webkit-transition-duration: .1s;
              transition: all .1s;
            }
            #line1, #line3 {
              -webkit-transition-property: all; /* Safari */
              -webkit-transition-duration: .4s; /* Safari */
              transition: all .4s;
            }
            &.active {
              #line1 {
                transform-origin: center;
                transform: translate(-3.5px, -3px) rotate(-45deg);
                -webkit-transition-property: all; /* Safari */
                -webkit-transition-duration: .4s; /* Safari */
                transition: all .4s;
              }
              #line2 {
                opacity: 0;
                -webkit-transition-property: all; /* Safari */
                -webkit-transition-duration: .1s;
                transition: all .1s;
              }
              #line3 {
                transform-origin: center;
                transform: translate(-3.5px, 7px) rotate(45deg);
                transition: all .4s;
              }
            }
          }
      }
    }
    .header-bar-cover {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
      width: 100vw;
      height: 100vh;
      display: flex;
      background-color: #000;
      
      justify-content: center;
      align-items: center;
      &.inactive {
        visibility: hidden;
        opacity: 0;
        -webkit-transition-property: all; /* Safari */
        -webkit-transition-duration: .4s; /* Safari */
        -webkit-transition-delay: .4s; /* Safari */
        transition-property: all;
        transition-duration: .4s;
        transition-delay: .4s;
      } 
      &.active {
        -webkit-transition-property: opacity; /* Safari */
        -webkit-transition-duration: .4s; /* Safari */
        -webkit-transition-delay: .4s; /* Safari */
        transition-property: opacity;
        transition-duration: .4s;
        transition-delay: .4s;
        visibility: visible;
        opacity: 1;
      }
      .cover-lists {
        color: #7b7a7a;
        list-style: none;
        padding: 0;
        .cover-list {
          margin-bottom: 35px;
          font-size: 20.8px;
          animation-delay: .8s;
          animation-name: fadein;
          animation-duration: .3s;
          animation-fill-mode: forwards;
          opacity: 0;
          transform: translateY(50%);        
          cursor: pointer;
          @keyframes fadein {
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          a {
            color: inherit;
            text-decoration: none;
            padding: 5px 0;
          }
          &.active {
            color: #fff;
          }
          &.active a:hover, &:hover a {
            color: #fff;
            animation-name: borderin;
            animation-duration: .2s;
            animation-fill-mode: forwards;
            @keyframes borderin {
              to {
                border-bottom: solid 2px #57B09F;
              }
            }
          }
        }
      }
    }
  }
</style>
